export default __webpack_public_path__ + "static/media/Calendar.74ea6b3c.png";